import React from "react";

export default function ListMenu({ userType = 7 }) {
  // add "small" class if userType === 1
  const sizeClass = userType === 1 ? "small" : "";

  return (
    <div className={`menuContainer primary white ${sizeClass}`}>
      {/* Conditional columns based on userType */}
      {userType === 1 && (
        <div className={`menuUsername ${sizeClass}`}>Super</div>
      )}

      {(userType === 1 || userType === 2) && (
        <div className={`menuUsername ${sizeClass}`}>Master</div>
      )}

      {/* Common columns */}
      <div className={`menuUsername ${sizeClass}`}>Username</div>
      <div className={`menuName ${sizeClass}`}>Credit</div>
      <div className={`menuName ${sizeClass}`}>Current</div>
      <div className={`menuUsername ${sizeClass}`}>Booked</div>
      <div className={`menuUsername ${sizeClass}`}>Live P&amp;L</div>
      <div className={`menuUsername ${sizeClass}`}>Net P&amp;L</div>
      <div className={`menuName ${sizeClass}`}>Super S</div>
      <div className={`menuName ${sizeClass}`}>Master S</div>
      <div className={`menuName ${sizeClass}`}>Broker S</div>
      <div className={`menuName ${sizeClass}`}>Super Live P&amp;L</div>
      <div className={`menuName ${sizeClass}`}>Master Live P&amp;L</div>
      <div className={`menuName ${sizeClass}`}>Broker Live P&amp;L</div>
    </div>
  );
}
